// extracted by mini-css-extract-plugin
module.exports = {"flexContainer":"flexContainer--1L5tP","message":"message--1KfOx"};